<template>
  <div class="home-container">
    <!-- SVG Definitions -->
    <svg style="display: none;">
      <!-- 头像1: 兔猫猫 -->
      <defs>
        <pattern id="avatar1" width="100%" height="100%">
          <svg width="40" height="40" viewBox="0 0 40 40">
            <circle cx="20" cy="20" r="20" fill="#FFE0B2"/>
            <!-- 猫耳朵 -->
            <path d="M8 15L20 22L14 8Z" fill="#FFB74D"/>
            <path d="M32 15L20 22L26 8Z" fill="#FFB74D"/>
            <!-- 脸部特征 -->
            <circle cx="15" cy="18" r="2" fill="#795548"/>
            <circle cx="25" cy="18" r="2" fill="#795548"/>
            <path d="M16 24Q20 28 24 24" stroke="#795548" stroke-width="2" fill="none"/>
            <!-- 兔子胡须 -->
            <line x1="12" y1="22" x2="8" y2="21" stroke="#795548"/>
            <line x1="12" y1="23" x2="8" y2="23" stroke="#795548"/>
            <line x1="12" y1="24" x2="8" y2="25" stroke="#795548"/>
            <line x1="28" y1="22" x2="32" y2="21" stroke="#795548"/>
            <line x1="28" y1="23" x2="32" y2="23" stroke="#795548"/>
            <line x1="28" y1="24" x2="32" y2="25" stroke="#795548"/>
          </svg>
        </pattern>
      </defs>

      <!-- 头像2: Ryan -->
      <defs>
        <pattern id="avatar2" width="100%" height="100%">
          <svg width="40" height="40" viewBox="0 0 40 40">
            <circle cx="20" cy="20" r="20" fill="#E3F2FD"/>
            <!-- 音乐主题装饰 -->
            <circle cx="15" cy="18" r="2" fill="#2196F3"/>
            <circle cx="25" cy="18" r="2" fill="#2196F3"/>
            <!-- 音符装饰 -->
            <path d="M14 12Q18 8 22 12" stroke="#2196F3" stroke-width="2"/>
            <path d="M28 15L24 18L28 21" fill="#2196F3"/>
            <!-- 微笑 -->
            <path d="M15 25Q20 29 25 25" stroke="#2196F3" stroke-width="2" fill="none"/>
            <!-- 音乐波浪 -->
            <path d="M8 20Q12 18 16 20Q20 22 24 20Q28 18 32 20" 
                  stroke="#90CAF9" stroke-width="1" fill="none"/>
          </svg>
        </pattern>
      </defs>
    </svg>

    <!-- 替换原有导航为 NavHeader 组件 -->
    <nav-header />
    
    <!-- 主要内容区 -->
    <div class="main-content">
      <!-- Hero区域 -->
      <div class="hero-section">
        <h1 class="main-title">你专心创作</h1>
        <h2 class="sub-title">知识极客帮你获得更多收入</h2>
        
        <div class="stats-info">
          <span class="number">12000+</span>
          创作者在知识极客，通过出售课程，文章，绘画，创意作品，软件，电子书，音乐，游戏，咨询服务，每月获得
          <span class="highlight">数百万元</span>
          收入。
          <div class="welcome-text">也欢迎你 ~~</div>
        </div>

        <div class="action-buttons">
          <router-link to="/home/creation/add">
          <el-button type="primary" size="large" class="start-btn">开始创作</el-button> </router-link>
          <router-link to="/discover"> <el-button size="large">探索更多</el-button></router-link>
        </div>
      </div>

      <!-- 使用步骤 -->
      <div class="steps-section">
        <h3 class="section-title">
          三步使用知识极客
        </h3>

        <div class="steps-container">
          <!-- 步骤1 -->
          <div class="step-item">
            <div class="step-number">1</div>
            <h4 class="step-title">创建内容</h4>
            <p class="step-desc">你可以创建图文/资料/音频/视频链接。</p>
            <div class="step-image">
              <img src="@/assets/image/FisO8RFQT7WDUl5GIgr-4RAK3Tsz.svg" alt="创建内容">
            </div>
          </div>

          <!-- 连接线 -->
          <div class="connect-line">
            <img src="@/assets/image/Fu9DOn2Sp1166Bpkb2U-xgUqwh6Y.svg" alt="连接线">
          </div>

          <!-- 步骤2 -->
          <div class="step-item">
            <div class="step-number">2</div>
            <h4 class="step-title">分享链接</h4>
            <p class="step-desc">将链接分享至你的粉丝聚集地如微博、公众号等。</p>
            <div class="step-image">
              <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <!-- 背景圆圈 -->
                <circle cx="60" cy="60" r="60" fill="#F5F6FA"/>
                
                <!-- 中心链接图标 -->
                <path d="M45 60C45 53.3726 50.3726 48 57 48H63C69.6274 48 75 53.3726 75 60C75 66.6274 69.6274 72 63 72H57C50.3726 72 45 66.6274 45 60Z" 
                      stroke="#FF6B00" 
                      stroke-width="4" 
                      stroke-linecap="round"/>
                
                <!-- 社交媒体图标 - 微信 -->
                <g transform="translate(25, 30)">
                  <circle cx="15" cy="15" r="12" fill="#07C160"/>
                  <path d="M10 15.5C11.5 15.5 12.5 14.5 12.5 13C12.5 11.5 11.5 10.5 10 10.5C8.5 10.5 7.5 11.5 7.5 13C7.5 14.5 8.5 15.5 10 15.5Z" fill="white"/>
                  <path d="M20 15.5C21.5 15.5 22.5 14.5 22.5 13C22.5 11.5 21.5 10.5 20 10.5C18.5 10.5 17.5 11.5 17.5 13C17.5 14.5 18.5 15.5 20 15.5Z" fill="white"/>
                </g>
                
                <!-- 社交媒体图标 - 微博 -->
                <g transform="translate(80, 30)">
                  <circle cx="15" cy="15" r="12" fill="#FF8200"/>
                  <path d="M15 20C18.866 20 22 17.3137 22 14C19 14 12 14.5 12 17.5C12 19.5 13.134 20 15 20Z" fill="white"/>
                  <circle cx="18" cy="12" r="2" fill="white"/>
                </g>
                
                <!-- 社交媒体图标 - 抖音 -->
                <g transform="translate(25, 75)">
                  <circle cx="15" cy="15" r="12" fill="#000000"/>
                  <path d="M13 22V11C13 11 16 12 18 12V15C18 15 16 14 13 14" stroke="white" stroke-width="2"/>
                  <path d="M13 15C13 18.5 15.5 20 18 20" stroke="white" stroke-width="2"/>
                </g>
                
                <!-- 社交媒体图标 - 小红书 -->
                <g transform="translate(80, 75)">
                  <circle cx="15" cy="15" r="12" fill="#FE2C55"/>
                  <path d="M11 12L15 19L19 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
                  <line x1="13" y1="15" x2="17" y2="15" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </g>
                
                <!-- 连接线 -->
                <path d="M45 45L60 60M75 45L60 60M45 75L60 60M75 75L60 60" 
                      stroke="#E0E0E0" 
                      stroke-width="2" 
                      stroke-dasharray="4 4"/>
              </svg>
            </div>
          </div>

          <!-- 连接线 -->
          <div class="connect-line">
            <img src="@/assets/image/Fu9DOn2Sp1166Bpkb2U-xgUqwh6Y.svg" alt="连接线">
          </div>

          <!-- 步骤3 -->
          <div class="step-item">
            <div class="step-number">3</div>
            <h4 class="step-title">获得收益</h4>
            <p class="step-desc">当你的作品被购买后当即获得收益。</p>
            <div class="step-image">
              <img src="@/assets/image/Fhf6AGhMdzT7cYk93wDJ50oQ3Meh.svg" alt="获得收益">
            </div>
          </div>
        </div>
      </div>

      <!-- 平台介绍 -->
      <div class="platform-intro">
        <h3 class="intro-title">创作者爱用的数字内容销售平台</h3>
      </div>
    </div>
    <div class="main-content">
      <!-- Hero section 保持不变 -->

      <!-- 创作者展示区域 -->
      <div class="creators-section">
        <el-carousel 
          :interval="4000" 
          type="card" 
          height="320px"
          :autoplay="true"
        >
          <el-carousel-item v-for="(creator, index) in creators" :key="index">
            <div class="creator-card">
              <div class="card-header">
                <div class="creator-info">
                  <el-avatar :size="40">
                    <svg width="40" height="40">
                      <circle cx="20" cy="20" r="20" :fill="creator.avatar"/>
                    </svg>
                  </el-avatar>
                  <div class="info">
                    <div class="name">{{ creator.name }}</div>
                    <div class="tags">
                      <span class="tag" v-for="(tag, tagIndex) in creator.tags" :key="tagIndex">
                        {{ tag }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="join-date">{{ creator.joinDate }}加入知识极客</div>
              </div>
              <div class="card-content">
                {{ creator.content }}
              </div>
              <div class="card-footer">
                <div class="stats">
                  <span class="works">{{ creator.worksCount }} 件作品在售</span>
                  <span class="divider">/</span>
                  <span class="sales">{{ creator.salesCount }} 人次购买</span>
                </div>
                <div class="works-preview">
                  <svg v-for="(work, index) in creator.works" 
                       :key="index"
                       :class="work.type"
                       width="60" 
                       height="60" 
                       viewBox="0 0 60 60">
                    <!-- 文章类型 -->
                    <template v-if="work.type === 'article'">
                      <rect width="60" height="60" rx="8" fill="#F5F6FA"/>
                      <rect x="12" y="14" width="36" height="4" rx="2" fill="#FF6B00"/>
                      <rect x="12" y="24" width="36" height="3" rx="1.5" fill="#E0E0E0"/>
                      <rect x="12" y="31" width="36" height="3" rx="1.5" fill="#E0E0E0"/>
                      <rect x="12" y="38" width="24" height="3" rx="1.5" fill="#E0E0E0"/>
                    </template>

                    <!-- 视频类型 -->
                    <template v-if="work.type === 'video'">
                      <rect width="60" height="60" rx="8" fill="#F5F6FA"/>
                      <circle cx="30" cy="30" r="15" fill="#FF6B00" opacity="0.9"/>
                      <path d="M36 30L27 35V25L36 30Z" fill="white"/>
                    </template>

                    <!-- 图片类型 -->
                    <template v-if="work.type === 'image'">
                      <rect width="60" height="60" rx="8" fill="#F5F6FA"/>
                      <circle cx="22" cy="22" r="6" fill="#FF6B00"/>
                      <path d="M12 42L22 32L28 38L38 25L48 42H12Z" fill="#FF6B00" opacity="0.9"/>
                    </template>

                    <!-- 音频类型 -->
                    <template v-if="work.type === 'audio'">
                      <rect width="60" height="60" rx="8" fill="#F5F6FA"/>
                      <rect x="20" y="20" width="4" height="20" rx="2" fill="#FF6B00">
                        <animate attributeName="height" values="20;10;20" dur="1s" repeatCount="indefinite"/>
                      </rect>
                      <rect x="28" y="15" width="4" height="30" rx="2" fill="#FF6B00">
                        <animate attributeName="height" values="30;15;30" dur="1.2s" repeatCount="indefinite"/>
                      </rect>
                      <rect x="36" y="25" width="4" height="10" rx="2" fill="#FF6B00">
                        <animate attributeName="height" values="10;25;10" dur="0.8s" repeatCount="indefinite"/>
                      </rect>
                    </template>
                  </svg>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 底部标语 -->
      <div class="bottom-slogan">
        <div class="slogan-text">
          每一份能满足他人需求的努力都值得被付费。
          <span class="brand">— 知识极客</span>
        </div>
        <router-link to="/home/creation/add">
          <el-button type="warning" size="large" class="join-btn">开始</el-button> </router-link>
      </div>
    </div>
    <footer class="modern-footer">
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-section">
            <div class="footer-brand">
              <h4>知识极客</h4>
              <p>支付后可见 · 扫码付费可见</p>
            </div>
          </div>
          
          <div class="footer-section">
            <div class="footer-links">
              <h5>服务条款</h5>
              <a href="/#/post-detail/19843" target="_blank">服务协议</a>
            </div>
          </div>
          
          <div class="footer-section">
            <div class="footer-links">
              <h5>友情链接</h5>
              <a href="https://www.nimingx.com" target="_blank">匿名信</a>
              <a href="https://www.imgbed.link" target="_blank">风筝图床</a>
            </div>
          </div>
          
          <div class="footer-section">
            <div class="back-to-top">
              <button @click="scrollToTop" class="top-btn">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 12L2 6L3.4 4.6L8 9.2L12.6 4.6L14 6L8 12Z" fill="currentColor"/>
                </svg>
                回到顶部
              </button>
            </div>
          </div>
        </div>
        
        <div class="footer-bottom">
          <div class="legal-info">
            <span>© 2025 知识极客 · 合肥聚合度</span>
            <div class="beian-links">
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402703690">
                <img src="https://www.klgeek.com/image/beian.png" alt="备案图标"/>
                皖公网安备 34010402703690号
              </a>
              <a href="https://beian.miit.gov.cn" target="_blank">皖ICP备2022003027号-9</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import NavHeader from '@/components/layout/NavHeader.vue'

export default {
  components: {
    NavHeader
  },
  data() {
    return {
      creators: [
        {
          name: '兔猫猫',
          avatar: '#avatar1',
          tags: ['公众号主', '色彩科学'],
          joinDate: '19.8.23',
          content: '鱼肉怎安利给粉丝啊各素，看了大家上传的作品，觉得大开，愿来年继续这么玩儿。能看得到鱼肉香的心态上传了我的公众号"真的起名无力"的文章合集...',
          worksCount: 16,
          salesCount: 570,
          works: [
            { type: 'article', title: '色彩搭配指南' },
            { type: 'video', title: '配色技巧教程' },
            { type: 'image', title: '作品展示集' }
          ]
        },
        {
          name: 'Ryan',
          avatar: '#avatar2',
          tags: ['音乐制作', '资源分享'],
          joinDate: '19.9.10',
          content: '很晚很晚总会将有些放弃的创意，但是很害怕一觉起来忘记自己早前的脑洞灵感和几天零碎好在了这个平台上...',
          worksCount: 2,
          salesCount: 22751,
          works: [
            { type: 'audio', title: '原创音乐集' },
            { type: 'video', title: '制作教程' }
          ]
        }
        // 可以添加更多创作者数据
      ]
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #fff6e5 0%, #fff 100%);

  // 主要内容区
  .main-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 80px 20px;

    // Hero区域
    .hero-section {
      text-align: center;
      margin-bottom: 100px;

      .main-title {
        font-size: 48px;
        font-weight: 600;
        color: #333;
        margin: 0 0 16px;
      }

      .sub-title {
        font-size: 36px;
        font-weight: 600;
        color: #333;
        margin: 0 0 40px;
      }

      .stats-info {
        font-size: 16px;
        color: #666;
        line-height: 1.8;
        max-width: 800px;
        margin: 0 auto 40px;

        .number {
          color: #ff6b00;
          font-weight: 600;
        }

        .highlight {
          color: #ff6b00;
          font-weight: 600;
        }

        .welcome-text {
          margin-top: 12px;
          color: #999;
        }
      }

      .action-buttons {
        display: flex;
        justify-content: center;
        gap: 20px;

        .start-btn {
          background: #ff6b00;
          border-color: #ff6b00;
          padding: 0 32px;
          height: 48px;
          font-size: 16px;
          border-radius: 24px;

          &:hover {
            background: #ff8124;
            border-color: #ff8124;
          }
        }

        .el-button {
          height: 48px;
          padding: 0 32px;
          font-size: 16px;
          border-radius: 24px;
        }
      }
    }

    // 使用步骤
    .steps-section {
      padding: 80px 0;
      
      .section-title {
        font-size: 32px;
        font-weight: 600;
        color: #333;
        margin-bottom: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        .title-icon {
          width: 24px;
          height: 24px;
        }
      }

      .steps-container {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 20px;
        padding: 0 20px;

        .step-item {
          flex: 1;
          max-width: 320px;
          text-align: center;
          position: relative;

          .step-number {
            width: 36px;
            height: 36px;
            background: #ff6b00;
            color: #fff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-weight: 600;
            margin: 0 auto 20px;
          }

          .step-title {
            font-size: 20px;
            font-weight: 600;
            color: #333;
            margin-bottom: 12px;
          }

          .step-desc {
            font-size: 14px;
            color: #666;
            line-height: 1.6;
            margin-bottom: 24px;
          }

          .step-image {
            width: 100%;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }
          }
        }

        .connect-line {
          width: 100px;
          padding-top: 100px;
          
          img {
            width: 100%;
            height: 212px;
          }
        }
      }
    }

    // 平台介绍
    .platform-intro {
      .intro-title {
        font-size: 32px;
        font-weight: 600;
        color: #333;
        margin: 0 0 40px;
        text-align: center;
        position: relative;
        display: inline-block;

        &::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          right: 0;
          height: 3px;
          background: #ff6b00;
          border-radius: 2px;
        }
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 768px) {
  .home-container {
    .main-content {
      padding: 40px 20px;

      .hero-section {
        margin-bottom: 60px;

        .main-title {
          font-size: 32px;
        }

        .sub-title {
          font-size: 24px;
        }

        .stats-info {
          font-size: 14px;
          padding: 0 20px;
        }
      }

      .steps-section {
        padding: 40px 0;

        .section-title {
          font-size: 24px;
          margin-bottom: 40px;
        }

        .steps-container {
          flex-direction: column;
          align-items: center;
          gap: 40px;

          .step-item {
            max-width: 100%;
          }

          .connect-line {
            display: none;
          }
        }
      }

      .platform-intro .intro-title {
        font-size: 24px;
      }
    }
  }
}
.creators-section {
  margin: 60px 0;
  padding: 0 20px;

  // 轮播样式调整
  :deep(.el-carousel__item) {
    border-radius: 12px;
  }

  :deep(.el-carousel__item--card) {
    width: 580px;
    
    &.is-active {
      .creator-card {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  .creator-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    height: 100%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    transform: scale(0.9);
    opacity: 0.8;
    transition: all 0.3s ease;
    
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 20px;

      .creator-info {
        display: flex;
        gap: 12px;
        align-items: center;

        .info {
          .name {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-bottom: 6px;
          }

          .tags {
            display: flex;
            gap: 8px;

            .tag {
              background: #f5f5f5;
              color: #666;
              padding: 2px 8px;
              border-radius: 4px;
              font-size: 12px;
            }
          }
        }
      }

      .join-date {
        background: #6c5ce7;
        color: #fff;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
      }
    }

    .card-content {
      color: #666;
      line-height: 1.6;
      margin-bottom: 20px;
      font-size: 14px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .card-footer {
      .stats {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        color: #666;
        font-size: 14px;

        .divider {
          color: #ddd;
        }
      }

      .works-preview {
        display: flex;
        gap: 8px;

        svg {
          margin-right: 8px;
          transition: transform 0.3s ease;
          
          &:hover {
            transform: scale(1.1);
          }
        }
      }
    }
  }
}

.bottom-slogan {
  text-align: center;
  margin: 80px 0;
  padding: 0 20px;

  .slogan-text {
    font-size: 24px;
    color: #333;
    margin-bottom: 32px;

    .brand {
      color: #ff6b00;
    }
  }

  .join-btn {
    height: 48px;
    padding: 0 40px;
    font-size: 16px;
    border-radius: 24px;
    background: #ff6b00;
    border-color: #ff6b00;

    &:hover {
      background: #ff8124;
      border-color: #ff8124;
    }
  }
}

// 响应式适配
@media screen and (max-width: 768px) {
  .creators-section {
    margin: 40px 0;
    
    :deep(.el-carousel__item--card) {
      width: 90vw;
    }

    .creator-card {
      padding: 16px;

      .card-header {
        .creator-info {
          gap: 8px;
        }
      }

      .card-footer {
        .works-preview svg {
          width: 50px;
          height: 50px;
        }
      }
    }
  }

  .bottom-slogan {
    margin: 40px 0;

    .slogan-text {
      font-size: 20px;
    }
  }
}

.works-container {
  display: flex;
  min-height: 100vh;
  background: #f6f8fa;
  padding: 24px;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  
  .content-area {
    margin: 0;
    flex: 1;
    max-width: 800px;
  }
  
  .category-nav {
    margin: 0;
  }
}

.page-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f6f8fa;
  display: flex;
  justify-content: center;
  padding: 0 16px;
}

svg {
  transition: transform 0.3s ease;
}

svg:hover {
  transform: scale(1.05);
}

@media screen and (max-width: 768px) {
  svg {
    width: 80px;
    height: 80px;
  }
}

/* 添加社交媒体图标的悬浮效果 */
svg g {
  transition: transform 0.3s ease;
  cursor: pointer;
}

svg g:hover {
  transform: scale(1.1);
}

/* 现代化Footer样式 */
.modern-footer {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: #ecf0f1;
  padding: 40px 0 20px;
  margin-top: 80px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #ff6b00 50%, transparent 100%);
  }
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 30px;
}

.footer-section {
  .footer-brand {
    h4 {
      font-size: 24px;
      font-weight: 600;
      color: #ff6b00;
      margin: 0 0 8px;
    }
    
    p {
      color: #bdc3c7;
      font-size: 14px;
      margin: 0;
    }
  }
  
  .footer-links {
    h5 {
      font-size: 16px;
      font-weight: 600;
      color: #ecf0f1;
      margin: 0 0 12px;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 0;
        width: 20px;
        height: 2px;
        background: #ff6b00;
        border-radius: 1px;
      }
    }
    
    a {
      display: block;
      color: #bdc3c7;
      text-decoration: none;
      font-size: 14px;
      margin-bottom: 8px;
      transition: all 0.3s ease;
      
      &:hover {
        color: #ff6b00;
        transform: translateX(4px);
      }
    }
  }
  
  .back-to-top {
    display: flex;
    justify-content: flex-end;
    
    .top-btn {
      background: linear-gradient(135deg, #ff6b00 0%, #ff8124 100%);
      color: white;
      border: none;
      padding: 12px 20px;
      border-radius: 25px;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(255, 107, 0, 0.3);
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(255, 107, 0, 0.4);
      }
      
      svg {
        transition: transform 0.3s ease;
      }
      
      &:hover svg {
        transform: translateY(-1px);
      }
    }
  }
}

.footer-bottom {
  border-top: 1px solid #34495e;
  padding-top: 20px;
  
  .legal-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    
    span {
      color: #95a5a6;
      font-size: 14px;
    }
    
    .beian-links {
      display: flex;
      gap: 20px;
      align-items: center;
      
      a {
        color: #95a5a6;
        text-decoration: none;
        font-size: 12px;
        display: flex;
        align-items: center;
        gap: 4px;
        transition: color 0.3s ease;
        
        &:hover {
          color: #ff6b00;
        }
        
        img {
          height: 16px;
          width: auto;
        }
      }
    }
  }
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .modern-footer {
    padding: 30px 0 15px;
    margin-top: 60px;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }
  
  .footer-section {
    .back-to-top {
      justify-content: center;
    }
  }
  
  .footer-bottom {
    .legal-info {
      flex-direction: column;
      text-align: center;
      gap: 15px;
      
      .beian-links {
        flex-direction: column;
        gap: 10px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .footer-container {
    padding: 0 15px;
  }
  
  .footer-section {
    .footer-brand h4 {
      font-size: 20px;
    }
    
    .footer-links h5 {
      font-size: 14px;
    }
  }
}
</style>